import {get as dotPropGet} from 'dot-prop';

const userProperties = {};

const getUserProperty = (key) => {
    return dotPropGet(userProperties, key);
};

const setUserProperties = (obj) => {
    Object.assign(userProperties, JSON.parse(JSON.stringify(obj)));
};

export {getUserProperty as default, getUserProperty, setUserProperties};


// WEBPACK FOOTER //
// ./src/app/utils/userProfile.js